import { propTypes } from '../../helpers'
import { Container } from 'react-bootstrap'
import { ContentPanel, Toolbar } from '../../components'
import styled from 'styled-components'
import { Helmet } from 'react-helmet-async'
import { useApplicationName } from '../../store'
import { useExternal } from '../../hooks'

const IFrameContainer = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 75%;
  iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
`

const ExternalPage = ({ category }) => {
  const applicationName = useApplicationName()
  const { external } = useExternal(category.id)

  return (
    <Container className='resizing-container'>
      <Helmet>
        <title>
          {category.name} - {applicationName}
        </title>
      </Helmet>
      <Toolbar title={category.name} />
      <ContentPanel>
        <IFrameContainer>
          <iframe src={external?.url} title={external?.name} />
        </IFrameContainer>
      </ContentPanel>
    </Container>
  )
}

ExternalPage.propTypes = { category: propTypes.categoryPropType }

export { ExternalPage }
